import { numCompare } from "@common/Common";
import { ValidationError } from "@common/types";
import { DiscreteScaleLevel } from "@Scales/Model";

export class CriterionScaleEditorViewModel
{
    opened: boolean = false;

    criterionId: number | null = null;
    criterionName: string | null = null;
    criterionDescription: string | null = null;
    levels: DiscreteScaleLevel[] | null = null;

    error: string | null = null;

    show(criterionId: number, criterionName: string, criterionDescription: string | null, levels: DiscreteScaleLevel[] | null)
    {
        this.criterionId = criterionId;
        this.criterionName = criterionName;
        this.criterionDescription = criterionDescription;
        this.levels = levels != null ? levels.sort((a, b) => numCompare(a.Value, b.Value)) : [];

        this.error = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.criterionId = null;
        this.criterionName = null;
        this.criterionDescription = null;
        this.levels = null;

        this.error = null;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        for (const error of errors)
        {
            if (error.Context === 'ScaleLevels')
            {
                this.error = error.Error;
            }
        }
    }
}